
export enum StepStatus {
  Idle = 'idle',
  Complete = 'complete',
  Failed = 'failed',
  Skipped = 'skipped'
}
